import React, { useState } from "react";
import { generateExcelReport, generateExcelReportAtendidas, generateExcelReportNoAtendidas } from "../../services/apiService";
import { BsDownload } from "react-icons/bs";
import Navbar from "../../bars/Navbar";
import Sidebar from "../../bars/Sidebar";
import { Col, Row } from "react-bootstrap";

export default function ExcelReport() {
  document.title = "Generar Reporte de Denuncias";

  const currentYear = new Date().getFullYear();
  const [fechas, setFechas] = useState({
    inicio: "",
    fin: "",
    anio: currentYear.toString(),
  });
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(null);

  // Generar opciones de años (desde 2022 hasta el año actual + 1)
  const years = Array.from({ length: currentYear - 2021 }, (_, i) => 2022 + i);

  // Versión alternativa más flexible
  const validarFechas = () => {
    if (!fechas.inicio || !fechas.fin) {
      setError("Debe seleccionar ambas fechas");
      setTimeout(() => {
        setError("");
      }, 1000);
      return false;

    }

    const fechaInicio = new Date(fechas.inicio);
    const fechaFin = new Date(fechas.fin);

    if (fechaInicio > fechaFin) {
      setError("La fecha de inicio no puede ser mayor a la fecha final");
      return false;
    }

    setError(null);
    return true;
  };

  const handleGenerarReporte = async (e) => {
    e.preventDefault();
    if (!validarFechas()) return;

    setLoading(true);
    setError(null);

    try {
      const payload = {
        fechaInicio: fechas.inicio,
        fechaFin: fechas.fin,
        anio: parseInt(fechas.anio),
      };

      const response = await generateExcelReport(payload);

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;

      // Obtener nombre del archivo de los headers o usar uno por defecto
      const contentDisposition = response.headers["content-disposition"];
      let fileName = `reporte-quejas-${fechas.anio}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      // Limpiar
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error en la generación del reporte:", error);
      setError(error.message || "Error al generar el reporte");
    } finally {
      setLoading(false);
    }
  };

  const handleGenerarReporteAtendidas = async (e) => {
    e.preventDefault();
    if (!validarFechas()) return;

    setLoading1(true);
    setError(null);

    try {
      const payload = {
        fechaInicio: fechas.inicio,
        fechaFin: fechas.fin,
        anio: parseInt(fechas.anio),
      };

      const response = await generateExcelReportAtendidas(payload);

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;

      // Obtener nombre del archivo de los headers o usar uno por defecto
      const contentDisposition = response.headers["content-disposition"];
      let fileName = `reporte-quejas-atendidas-${fechas.anio}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      // Limpiar
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error en la generación del reporte:", error);
      setError(error.message || "Error al generar el reporte");
    } finally {
      setLoading1(false);
    }
  };

  const handleGenerarReporteNoAtendidas = async (e) => {
    e.preventDefault();
    if (!validarFechas()) return;

    setLoading2(true);
    setError(null);

    try {
      const payload = {
        fechaInicio: fechas.inicio,
        fechaFin: fechas.fin,
        anio: parseInt(fechas.anio),
      };

      const response = await generateExcelReportNoAtendidas(payload);

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;

      // Obtener nombre del archivo de los headers o usar uno por defecto
      const contentDisposition = response.headers["content-disposition"];
      let fileName = `reporte-quejas-no-atendidas-${fechas.anio}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      // Limpiar
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error en la generación del reporte:", error);
      setError(error.message || "Error al generar el reporte");
    } finally {
      setLoading2(false);
    }
  };

  return (
    <>
      <div className="flex">
        <Sidebar />
        <div className="content w-100 cont">
          <Navbar />
          <div className="col-md-12 text-center" >
            <div className="card1 card1-size">
              <h5 className="mb-4 text-dark">
                <BsDownload className="me-2" />
                Generar Reporte
              </h5>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <Row>
                <Col Col xs={12} md={6} lg={4}>
                  <label className="form-label mb-1">Año del reporte</label>
                  <select
                    className="form-select"
                    value={fechas.anio}
                    onChange={(e) =>
                      setFechas((prev) => ({ ...prev, anio: e.target.value }))
                    }
                    required
                    style={{ minWidth: 140 }}
                  >
                    <option value="">Seleccione año</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <label className="form-label mb-1">Fecha inicial</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fechas.inicio}
                    onChange={(e) =>
                      setFechas((prev) => ({ ...prev, inicio: e.target.value }))
                    }
                    min={`${fechas.anio}-01-01`}
                    max={`${fechas.anio}-12-31`}
                    required
                    style={{ minWidth: 180 }}
                  />
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <label className="form-label mb-1">Fecha final</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fechas.fin}
                    onChange={(e) =>
                      setFechas((prev) => ({ ...prev, fin: e.target.value }))
                    }
                    min={fechas.inicio || `${fechas.anio}-01-01`}
                    max={`${fechas.anio}-12-31`}
                    required
                    style={{ minWidth: 180 }}
                  />
                </Col>
              </Row>

              <br />

              <Row>
                <Col Col xs={12} md={6} lg={4}>
                  <form onSubmit={handleGenerarReporte}>
                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Generando...
                        </>
                      ) : (
                        "Descargar Reporte General "
                      )}
                    </button>
                  </form>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <form onSubmit={handleGenerarReporteAtendidas}>
                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={loading1}
                    >
                      {loading1 ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Generando...
                        </>
                      ) : (
                        "Descargar Reporte Atendidas"
                      )}
                    </button>
                  </form>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <form onSubmit={handleGenerarReporteNoAtendidas}>
                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={loading2}
                    >
                      {loading2 ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Generando...
                        </>
                      ) : (
                        "Descargar Reporte No Atendidas"
                      )}
                    </button>
                  </form>
                </Col>
              </Row>



              <div className="mt-3">
                <small className="text-muted">
                  *Importante: En caso que el rango de fechas no tenga registros,
                  se generará un reporte vacío.
                </small>
              </div>

            </div>
          </div>
        </div>
      </div>




    </>
  );
}